import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconAI(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20ZM12.2076 20H20V12.2012C16.0979 12.9981 13.0204 16.0807 12.2076 20ZM12.2076 4H20V11.7988C16.0979 11.0019 13.0204 7.91928 12.2076 4ZM11.7858 4H4V11.7974C7.89901 10.9985 10.9735 7.91708 11.7858 4ZM4 12.2026C7.89901 13.0015 10.9735 16.0829 11.7858 20H4V12.2026Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
